import React from 'react';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMFormCheckBox from 'components/dashboard/form/SMFormCheckBox';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormTextArea from 'components/dashboard/form/SMFormTextArea';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMConciergeFormView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      concierge: this.props.concierge,
    };
  }

  componentWillMount() {
    const concierge = this.state.concierge;
    concierge.accept_term_of_service = false;
    this.setState({
      concierge: concierge,
    });
  }

  fieldDidChange(e) {
    let name = e.currentTarget.name,
        value = e.currentTarget.value,
        concierge = this.state.concierge;

    if (/concierge\[\w*\]/.test(name)) {
      const start = name.indexOf( "[" );
      const end = name.indexOf( "]" );
      name = name.slice( start+1, end );
    }

    concierge[name] = e.currentTarget.type == 'checkbox' ? e.currentTarget.checked : value;
    this.setState({
      concierge: concierge
    });
  }

  selectBoxDidChangeValue(e) {
    this.fieldDidChange(e);
  }

  textAreaDidEndEditing(e) {
    this.fieldDidChange(e);
  }

  textFieldDidEndEditing(e) {
    this.fieldDidChange(e);
  }

  checkBoxDidChangeValue(e) {
    this.fieldDidChange(e);
  }

  formDidSubmit(e) {
    e.preventDefault();
    let form = this.refs.form,
        formData = new FormData(form),
        queries = {};

    SMOwnerResource.postConcierge(formData, queries, (data, error, xhr)=> {
      if (xhr.status == 201) {
        window.location.href = Routes.sent_concierge_index_path({reservation_id: data["reservation"]["id"]});
      } else {
        var errors = xhr.responseJSON.errors;

        this.setState({
          errors: errors
        });
      }
    });
  }

  canSendForm() {
    let concierge = this.state.concierge;
    let canSendForm = concierge.event_type &&
                      concierge.capacity &&
                      concierge.location != 'anywhere' &&
                      concierge.max_budget &&
                      concierge.content &&
                      concierge.family_name &&
                      concierge.given_name &&
                      concierge.email &&
                      concierge.tel &&
                      concierge.postal_code &&
                      concierge.state &&
                      concierge.city &&
                      concierge.address_1 &&
                      concierge.corp_name &&
                      concierge.industry_id &&
                      concierge.job_id &&
                      concierge.accept_term_of_service == true;

    return (!!canSendForm);
  }

  renderError(field) {
    let errorText = SMFormatHelper.errorText('Concierge', field, this.state.errors);

    return(
      <SMFormValidationMessage
        name={field}
        withIcon={true}
        errorText={errorText} />
    );
  }

  generatePullDown(items, default_title) {
    let selectBoxItems = [];

    if (default_title) {
      selectBoxItems.push(
        {value: '', label: default_title}
      );
    }

    for(let i=0; i<items.length; i++) {
      selectBoxItems.push(
        {value: items[i].name, label: items[i].name_text}
      );
    }
    return selectBoxItems;
  }

  renerHiddenForms() {
    let concierge = this.props.concierge;
    let row = [];
    if (concierge.state) {
      row.push(<input type='hidden' key='state' name='state' value={concierge.state} />);
    }
    if (concierge.department) {
      row.push(<input type='hidden' key='department' name='department' value={concierge.department} />);
    }
    if (concierge.address_1) {
      row.push(<input type='hidden' key='address_1' name='address_1' value={concierge.address_1} />);
    }
    if (concierge.address_2) {
      row.push(<input type='hidden' key='address_2' name='address_2' value={concierge.address_2} />);
    }
    if (concierge.postal_code) {
      row.push(<input type='hidden' key='postal_code' name='postal_code' value={concierge.postal_code} />);
    }
    if (concierge.fax) {
      row.push(<input type='hidden' key='fax' name='fax' value={concierge.fax} />);
    }
    row.push(<input type='hidden' key='has_food' name='has_food' value='' />);

    return (
      <div>
        {row}
      </div>
    );
  }

  render() {
    let submitClassName = "pt13 pb13 w250 inquiry-header__form-submit",
        submitDisabled = true;

    if (this.canSendForm()) {
      submitClassName += " button-blue";
      submitDisabled = false;
    } else {
      submitClassName += " button-disabled";
    }

    return (
      <form ref='form' onSubmit={this.formDidSubmit.bind(this)}>
        <div className="inquiry-header__form col-sm-12 col-md-5">
          <div className="inquiry-header__form-area clearfix">
            <span className="service-select__bg inquiry-header__form-purpose">
              <span className="service-select">
                <SMFormSelectBox
                  name='event_type'
                  items={this.generatePullDown(this.props.eventTypeList, '目的：[例]イベント')}
                  selectedValue={this.state.concierge.event_type}
                  options={{className: "service-select__purpose w100pa"}}
                  delegate={this} />
              </span>
            </span>
            <span className="service-select__bg inquiry-header__form-purpose">
              <span className="service-select">
                <SMFormSelectBox
                  name='capacity'
                  items={this.generatePullDown(this.props.capacityList, '人数：[例]100人')}
                  selectedValue={this.state.concierge.capacity}
                  options={{className: "service-select__purpose w100pa"}}
                  delegate={this} />
              </span>
            </span>
            {this.renderError('capacity')}
            {this.renderError('event_type')}
          </div>
          <div className="inquiry-header__form-area clearfix">
            <span className="service-select__bg inquiry-header__form-purpose">
              <span className="service-select">
                <SMFormSelectBox
                  name='location'
                  items={this.generatePullDown(this.props.areaList, '希望エリア：[例]東京都内')}
                  selectedValue={this.state.concierge.location}
                  options={{className: "service-select__purpose w100pa"}}
                  delegate={this} />
              </span>
            </span>
            <SMFormTextField
              value={this.state.concierge.max_budget}
              name='max_budget'
              options={{className: "inquiry-header__form-purpose form-text"}}
              placeholderText="イベントご予算総額：200000"
              delegate={this} />
            {this.renderError('location')}
            {this.renderError('max_budget')}
          </div>
          <div className="inquiry-header__form-area">
            <SMFormTextArea
              name='content'
              value={this.state.concierge.content}
              options={{className: "form-text inquiry-header__form-textarea"}}
              placeholderText="200名規模の会社の設立記念日パーティーをやりたいと思っております。普段とは違った、おしゃれなゲストハウスやクラブなど、社員の思い出に残るような場所で開催したいと思っています。場所は新宿・渋谷・原宿周辺希望です。食事は立食形式で、19:00〜21:00くらいの時間です。"
              delegate={this} />
            {this.renderError('content')}
          </div>
          <div className="inquiry-header__form-area clearfix">
            <SMFormTextField
              value={this.state.concierge.family_name}
              name='family_name'
              options={{className: "inquiry-header__form-name form-text"}}
              placeholderText="姓"
              delegate={this} />
            <SMFormTextField
              value={this.state.concierge.given_name}
              name='given_name'
              options={{className: "inquiry-header__form-name  form-text"}}
              placeholderText="名"
              delegate={this} />
            {this.renderError('family_name')}
            {this.renderError('given_name')}
          </div>
          <div className="inquiry-header__form-area clearfix">
            <SMFormTextField
              value={this.state.concierge.postal_code}
              name='postal_code'
              options={{className: "inquiry-header__form-purpose form-text"}}
              placeholderText="郵便番号：1600023"
              delegate={this} />
            <span className="service-select__bg inquiry-header__form-purpose">
              <span className="service-select">
                <SMFormSelectBox
                  name='state'
                  selectedValue={this.state.concierge.state}
                  items={this.generatePullDown(this.props.areaList, '都道府県')}
                  options={{className: "service-select__purpose w100pa"}}
                  delegate={this} />
              </span>
            </span>
            {this.renderError('postal_code')}
            {this.renderError('state')}
          </div>
          <div className="inquiry-header__form-area">
            <SMFormTextField
              value={this.state.concierge.city}
              name='city'
              options={{className: "form-text w100pa"}}
              placeholderText="市区町村：新宿区"
              delegate={this} />
            {this.renderError('city')}
          </div>
          <div className="inquiry-header__form-area">
            <SMFormTextField
              value={this.state.concierge.address_1}
              name='address_1'
              options={{className: "form-text w100pa"}}
              placeholderText="町名・番地：西新宿6-15-1"
              delegate={this} />
            {this.renderError('address_1')}
          </div>
          <div className="inquiry-header__form-area">
            <SMFormTextField
              value={this.state.concierge.address_2}
              name='address_2'
              options={{className: "form-text w100pa"}}
              placeholderText="ビル名・部屋番号：セントラルパークタワー ラ・トゥール新宿 608"
              delegate={this} />
            {this.renderError('address_2')}
          </div>
          <div className="inquiry-header__form-area">
            <SMFormTextField
              value={this.state.concierge.tel}
              type="tel"
              name='tel'
              options={{className: "form-text w100pa"}}
              placeholderText="電話番号：0363045618"
              delegate={this} />
            {this.renderError('tel')}
          </div>
          <div className="inquiry-header__form-area">
            <SMFormTextField
              value={this.state.concierge.corp_name}
              name='corp_name'
              options={{className: "form-text w100pa"}}
              placeholderText="法人・団体名"
              delegate={this} />
            {this.renderError('corp_name')}
          </div>
          <div className="inquiry-header__form-area clearfix">
            <span className="service-select__bg inquiry-header__form-department">
              <span className="service-select">
                <SMFormSelectBox
                  name='industry_id'
                  selectedValue={this.state.concierge.industry_id}
                  items={this.generatePullDown(this.props.industryList, '業種')}
                  options={{className: "service-select__purpose w100pa"}}
                  delegate={this} />
              </span>
            </span>
            <span className="service-select__bg inquiry-header__form-department">
              <span className="service-select">
                <SMFormSelectBox
                  name='job_id'
                  selectedValue={this.state.concierge.job_id}
                  items={this.generatePullDown(this.props.jobList, '職種')}
                  options={{className: "service-select__purpose w100pa"}}
                  delegate={this} />
              </span>
            </span>
            {this.renderError('industry_list')}
            {this.renderError('job_list')}
          </div>
          <div className="inquiry-header__form-set clearfix">
            <div className="inquiry-header__form-terms">
              <input type='hidden' key={'0-hidden'} name='accept_term_of_service' value='0' />
              <SMFormCheckBox
                value={1}
                id="inquiry-form__checkbox"
                name='accept_term_of_service'
                checked={this.state.concierge.accept_term_of_service}
                delegate={this} />
              <label htmlFor="inquiry-form__checkbox" className="form-checkbox__s">
                <a href="https://spacemarket.com/about/terms_of_space_use" target="_blank" className="a__underline">利用規約</a>に同意する
              </label>
              {this.renderError('accept_term_of_service')}
            </div>
            {this.renerHiddenForms()}
            <input type="submit" value="この内容で送信する" className={submitClassName} disabled={submitDisabled} />
          </div>
        </div>
      </form>
    );
  }
}
export default SMConciergeFormView;



// WEBPACK FOOTER //
// ./app/javascript/components/concierge/SMConciergeFormView.jsx